import React, { SVGProps } from 'react';

import { withCustomIcon } from './withCustomIcon';

const PhoneIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_90_360)">
                <path d="M3.99985 0V21C3.99985 21.7956 4.31592 22.5587 4.87853 23.1213C5.44114 23.6839 6.2042 24 6.99985 24H16.9998C17.7955 24 18.5586 23.6839 19.1212 23.1213C19.6838 22.5587 19.9998 21.7956 19.9998 21V0H3.99985ZM17.9998 2V16H5.99985V2H17.9998ZM16.9998 22H6.99985C6.73463 22 6.48028 21.8946 6.29274 21.7071C6.1052 21.5196 5.99985 21.2652 5.99985 21V18H17.9998V21C17.9998 21.2652 17.8945 21.5196 17.707 21.7071C17.5194 21.8946 17.2651 22 16.9998 22Z" fill="#374957" />
                <path d="M12.9997 18.9994H10.9997V20.9994H12.9997V18.9994Z" fill="#374957" />
            </g>
            <defs>
                <clipPath id="clip0_90_360">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default withCustomIcon(PhoneIcon);